module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hallau-68534b2b2744bdb5a3c19114c9d83315.png";